module.exports = __webpack_public_path__ + "static/media/vscode.e00a3569.svg";